import type { InvoiceRecord } from "@/repositories/invoice-records";

type InvoicePageLoad = { invoice: Pick<InvoiceRecord, "invoice_number"> | null; loading: boolean; error: string | null };

function currentPageName({ invoice, loading, error }: InvoicePageLoad): string {
  if (invoice) return `Invoice #${invoice.invoice_number}`;
  if (loading) return "Loading...";
  return error ? "Invoice" : "Not found";
}

export const invoiceBreadcrumb = (load: InvoicePageLoad) => [
  { name: "Invoices", href: "/invoices" },
  { name: currentPageName(load), href: "#" },
];
